import { NODE_BASE_URL } from './serviceHelper'

const publicService = {
  contactUs: async (details) => {
    return await fetch(`${NODE_BASE_URL}/contact-us/`, {
      method: 'POST',
      body: JSON.stringify(details),
      headers: { 'Content-Type': 'application/json' },
    })
  },
}

export default publicService
